// src/redux/reducers/serviceTypeReducer.js
const initialState = {
    serviceType: 'TourPackage'  // default value (you can change this based on your needs)
  };
  
  const serviceTypeReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_SERVICE_TYPE':
        return {
          ...state,
          serviceType: action.payload  // Update serviceType based on the action
        };
      default:
        return state;
    }
  };
  
  export default serviceTypeReducer;
  